import type { ListSeriesQuery } from '@vmt/shared';

export const qk = {
  config: ['config'] as const,
  me: ['auth', 'me'] as const,
  maps: ['maps'] as const,
  agents: ['agents'] as const,
  rankTiers: ['rank-tiers'] as const,
  players: ['players'] as const,
  player: (id: string) => ['players', id] as const,
  playerStats: (id: string) => ['stats', 'players', id] as const,
  headToHead: (a: string, b: string) => ['stats', 'h2h', a, b] as const,
  seriesList: (query: Partial<ListSeriesQuery>) => ['series', 'list', query] as const,
  series: (id: string) => ['series', 'detail', id] as const,
  dashboard: ['stats', 'dashboard'] as const,
  leaderboard: ['stats', 'leaderboard'] as const,
  highlights: ['stats', 'highlights'] as const,
  mapStats: ['stats', 'maps'] as const,
  agentStats: ['stats', 'agents'] as const,
  users: ['users'] as const,
  invites: ['invites'] as const,
  settings: ['settings'] as const,
};
